export var COLLAPSED_ORG_SELECTOR_WIDTH = 56;
export var DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH = 200;
export var MIN_ORG_SELECTOR_EXPAND_WIDTH = COLLAPSED_ORG_SELECTOR_WIDTH + (DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH - COLLAPSED_ORG_SELECTOR_WIDTH) / 2;
export var MAX_ORG_SELECTOR_EXPANDED_WIDTH = 400;
export var ORG_SELECTOR_WIDTH_LS_KEY = 'AS_ORG_SELECTOR_WIDTH';
export var ASSETS_APP_KEY = 'ASSETS';